import { fullDate } from '../func';

export const FulfillmentTypeEnum = Object.freeze({
    WHOLE_DURATION: 'whole-duration',
    SPACE: 'space',
    ROOM: 'room',
    RESTAURANT: 'restaurant',
    ACTIVITY: 'activity',
    SPECIFIC_DAY: 'specific-day',
    ACCOMMODATION: 'accommodation',
    ARRANGED_LATER: 'arranged-later',
});

function isWholeDuration(section) {
    return (
        section.fulfillment_type === FulfillmentTypeEnum.WHOLE_DURATION ||
        section.fulfillment_type === FulfillmentTypeEnum.SPACE
    );
}

function isSpace(section) {
    return section.fulfillment_type === FulfillmentTypeEnum.SPACE;
}

function isRoom(section) {
    return section.fulfillment_type === FulfillmentTypeEnum.ROOM;
}

function isRestaurant(section) {
    return section.fulfillment_type === FulfillmentTypeEnum.RESTAURANT;
}

function isSpecificDay(section) {
    return section.fulfillment_type === FulfillmentTypeEnum.SPECIFIC_DAY;
}

function isAccommodation(section) {
    return section.fulfillment_type === FulfillmentTypeEnum.ACCOMMODATION;
}

function isArrangedLater(section) {
    return section.fulfillment_type === FulfillmentTypeEnum.ARRANGED_LATER;
}

function isActivity(section) {
    return section.fulfillment_type === FulfillmentTypeEnum.ACTIVITY;
}

function isEditableDates(section) {
    return (
        section.fulfillment_type === FulfillmentTypeEnum.ACTIVITY ||
        section.fulfillment_type === FulfillmentTypeEnum.RESTAURANT
    );
}

function isDateTimeDuration(section) {
    return isWholeDuration(section) || isRestaurant(section) || isSpace(section) || isActivity(section);
}

function isDateDuration(section) {
    return isRoom(section) || isAccommodation(section);
}

export const FulfillmentType = {
    isWholeDuration,
    isSpecificDay,
    isAccommodation,
    isActivity,
    isSpace,
    isRoom,
    isArrangedLater,
    isEditableDates,
    isDateTimeDuration,
    isDateDuration,
};

export const FulfillmentTypeMixin = {
    mixins: [fullDate],
    data() {
        return {
            fulfillmentTypeOptions: [
                { value: null, displayName: '⎯' },
                {
                    value: FulfillmentTypeEnum.WHOLE_DURATION,
                    displayName: this.fulfillmentTypeDisplayName(FulfillmentTypeEnum.WHOLE_DURATION),
                },
                {
                    value: FulfillmentTypeEnum.SPACE,
                    displayName: this.fulfillmentTypeDisplayName(FulfillmentTypeEnum.SPACE),
                },
                {
                    value: FulfillmentTypeEnum.ROOM,
                    displayName: this.fulfillmentTypeDisplayName(FulfillmentTypeEnum.ROOM),
                },
                {
                    value: FulfillmentTypeEnum.ACTIVITY,
                    displayName: this.fulfillmentTypeDisplayName(FulfillmentTypeEnum.ACTIVITY),
                },
                {
                    value: FulfillmentTypeEnum.RESTAURANT,
                    displayName: this.fulfillmentTypeDisplayName(FulfillmentTypeEnum.RESTAURANT),
                },
                {
                    value: FulfillmentTypeEnum.SPECIFIC_DAY,
                    displayName: this.fulfillmentTypeDisplayName(FulfillmentTypeEnum.SPECIFIC_DAY),
                },
                {
                    value: FulfillmentTypeEnum.ACCOMMODATION,
                    displayName: this.fulfillmentTypeDisplayName(FulfillmentTypeEnum.ACCOMMODATION),
                },
                {
                    value: FulfillmentTypeEnum.ARRANGED_LATER,
                    displayName: this.fulfillmentTypeDisplayName(FulfillmentTypeEnum.ARRANGED_LATER),
                },
            ],
        };
    },
    methods: {
        fulfillmentTypeDisplayName(fulfillmentType) {
            let displayNameMap = {};
            displayNameMap[FulfillmentTypeEnum.WHOLE_DURATION] = this.$t('Whole duration');
            displayNameMap[FulfillmentTypeEnum.SPACE] = this.$t('Space');
            displayNameMap[FulfillmentTypeEnum.ACTIVITY] = this.$t('Activity');
            displayNameMap[FulfillmentTypeEnum.RESTAURANT] = this.$t('Restaurant');
            displayNameMap[FulfillmentTypeEnum.SPECIFIC_DAY] = this.$t('Specific day');
            displayNameMap[FulfillmentTypeEnum.ACCOMMODATION] = this.$t('Accommodation');
            displayNameMap[FulfillmentTypeEnum.ROOM] = this.$t('Room');
            displayNameMap[FulfillmentTypeEnum.ARRANGED_LATER] = this.$t('Arranged later');
            return displayNameMap[fulfillmentType];
        },
        sectionFulfillmentText(section, builder = false) {
            if (
                section.fulfillment_type === FulfillmentTypeEnum.WHOLE_DURATION ||
                section.fulfillment_type === FulfillmentTypeEnum.SPACE ||
                section.fulfillment_type === FulfillmentTypeEnum.RESTAURANT
            ) {
                return this.$t('From start to end');
            } else if (
                section.fulfillment_type === FulfillmentTypeEnum.SPECIFIC_DAY ||
                section.fulfillment_type === FulfillmentTypeEnum.ACTIVITY
            ) {
                if (builder) {
                    return this.$t('Day') + ' ' + section.days[0];
                } else {
                    return this.fullDate(section.dates[0]);
                }
            } else if (
                section.fulfillment_type === FulfillmentTypeEnum.ACCOMMODATION ||
                section.fulfillment_type === FulfillmentTypeEnum.ROOM
            ) {
                return this.$t('From start to end');
            } else {
                return this.$t('Arranged later');
            }
        },
        isDateTimeDuration(section) {
            return isDateTimeDuration(section);
        },
        isDateDuration(section) {
            return isDateDuration(section);
        },
        isWholeDuration(section) {
            return isWholeDuration(section);
        },
        isSpecificDay(section) {
            return isSpecificDay(section);
        },
        isRestaurant(section) {
            return isRestaurant(section);
        },
        isSpace(section) {
            return isSpace(section);
        },
        isRoom(section) {
            return isRoom(section);
        },
        isAccommodation(section) {
            return isAccommodation(section);
        },
        isArrangedLater(section) {
            return isArrangedLater(section);
        },
        isActivity(section) {
            return isActivity(section);
        },
        disabledServiceInfo(section) {
            return this.isWholeDuration(section) || this.isRestaurant(section) || this.isActivity(section);
        },
        isEditableDates(section) {
            return this.isSpecificDay(section) || this.isRestaurant(section) || this.isActivity(section);
        },
        sectionHasStartTime(section) {
            return this.isDateTimeDuration(section);
        },
        sectionHasEndTime(section) {
            return this.isDateTimeDuration(section);
        },
        sectionHasEndDate(section) {
            return this.isDateTimeDuration(section) || this.isDateDuration(section);
        },
    },
};
